var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-main-container--call-logs" },
    [
      _c("ReportingCallLogsSettings", {
        staticClass: "reporting-settings-container m-b-10",
        on: {
          refreshCallLogsData: _vm.handleCallLogsRefresh,
          onStartTour: _vm.userTriggerStartTour,
          dateRangeChange: _vm.handleDateRangeChange
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "reporting-call-logs-data" },
        [
          _c("div", { staticClass: "reporting-call-logs-header m-b-15" }, [
            _c("div", { staticClass: "reporting-call-logs-header__title" }, [
              _vm._v("\n        Timeline\n      ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "reporting-call-logs-header__right" },
              [
                _vm.histogramActions.length
                  ? _c(
                      "button",
                      {
                        staticClass: "btn m-r-10",
                        on: { click: _vm.zoomOutHistogram }
                      },
                      [
                        _c("i", { staticClass: "fa fa-search-minus" }),
                        _vm._v("\n          Zoom out\n        ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.sectionsVisibility["timeline"]
                  ? _c("SearchableDropdown", {
                      staticClass:
                        "call-logs__time-group-dropdown input-md m-r-15",
                      attrs: {
                        config: _vm.timeGroupDropdownOptions,
                        placeholder: "Interval",
                        rules: "required"
                      },
                      model: {
                        value: _vm.timeGroupBy,
                        callback: function($$v) {
                          _vm.timeGroupBy = $$v
                        },
                        expression: "timeGroupBy"
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-list-function",
                attrs: { href: "javascript:;" },
                on: {
                  click: function($event) {
                    return _vm.toggleSection("timeline")
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "typcn",
                  class: {
                    "typcn-arrow-sorted-up": _vm.sectionsVisibility["timeline"],
                    "typcn-arrow-sorted-down": !_vm.sectionsVisibility[
                      "timeline"
                    ]
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _vm.sectionsVisibility["timeline"]
            ? _c("HighchartsCallHistogram", {
                attrs: {
                  data: _vm.histogramData,
                  "moment-timezone-id": _vm.activeCallLogTranslatedTimeZoneId,
                  "group-time-interval": _vm.groupTimeInterval,
                  "computed-time-group-interval":
                    _vm.histogramTimeGroupInterval,
                  "show-loader": _vm.showHistogramLoader,
                  "time-range": _vm.activeCallLogTimeRange
                },
                on: { onRangeSelection: _vm.handleChartRangeSelection }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "reporting-call-logs-header m-b-15" }, [
            _c("div", { staticClass: "reporting-call-logs-header__title" }, [
              _vm._v("\n        Summary\n      ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "reporting-call-logs-header__right" }, [
              _vm.canExportReport
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm m-r-15 export-summary-btn",
                      attrs: { disabled: _vm.disableQuickInsightsExport },
                      on: { click: _vm.exportQuickInsightsReport }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("EXPORT_CSV")) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-list-function",
                  attrs: { href: "javascript:;" },
                  on: {
                    click: function($event) {
                      return _vm.toggleSection("quickInsights")
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "typcn",
                    class: {
                      "typcn-arrow-sorted-up":
                        _vm.sectionsVisibility["quickInsights"],
                      "typcn-arrow-sorted-down": !_vm.sectionsVisibility[
                        "quickInsights"
                      ]
                    }
                  })
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _vm.sectionsVisibility["quickInsights"]
            ? _c("ReportingCallLogsQuickInsights", {
                staticClass: "m-b-20",
                attrs: {
                  "col-defs-loaded-from-api": _vm.insightsColDefsLoadedFromAPI,
                  "column-defs": _vm.quickInsightsColumns,
                  "row-data": _vm.quickFilterData,
                  "tab-groupings": _vm.quickFilterInsightsTabs,
                  "refresh-grid-data": _vm.refreshGridData,
                  "column-state": _vm.quickFilterInsightsColumnState,
                  "show-loader": _vm.quickFilterInsightsLoader,
                  "tag-group-bys": _vm.tagGroupBys,
                  "hide-tags": _vm.hideTags,
                  "select-tab-grouping": _vm.quickInsightsTabGrouping,
                  role: _vm.role,
                  "export-quick-insights-trigger":
                    _vm.exportQuickInsightsTrigger
                },
                on: {
                  loadData: _vm.loadQuickFilterInsightsData,
                  filterByColumn: _vm.handleFilterByColumn,
                  filterByDate: _vm.handleFilterByDate,
                  changeTabGrouping: _vm.onQuickInsightsTabChange,
                  gridStateChange: _vm.onCallLogSummaryGridStateChange
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.sectionsVisibility["callLog"]
            ? _c("ReportingCallLogsGrid", {
                ref: "reportingCallLogsGrid",
                staticClass: "m-t-15",
                attrs: {
                  "call-logs-data": _vm.quickFilterData,
                  "col-defs-loaded-from-api": _vm.callLogsColDefsLoadedFromAPI,
                  "column-defs": _vm.callLogColumns,
                  "grid-state": _vm.gridState,
                  "show-call-log-action-loader-status":
                    _vm.showCallLogActionLoaderStatus,
                  "call-log-action-form-visibility-status":
                    _vm.callLogActionFormVisibilityStatus,
                  campaigns: _vm.campaigns,
                  "refresh-grid-data": _vm.refreshGridData,
                  role: _vm.role,
                  "is-admin": _vm.isReportingAdmin,
                  "is-read-only-report-user": _vm.isReadOnlyReportUser,
                  "is-buyer": _vm.isBuyer,
                  "recent-call-tags": _vm.recentCallTags,
                  "show-audio-player-for-call": _vm.showAudioPlayerForCall,
                  "call-log-details-mapping": _vm.callLogDetailsMapping,
                  "blocked-numbers-hash-map": _vm.blockedNumbersHashMap,
                  "show-bulk-action-loader": _vm.showBulkActionLoader,
                  "hide-bulk-action-form": _vm.triggerBulkActionHide,
                  "time-zone-id": _vm.activeCallLogTranslatedTimeZoneId,
                  "can-dispute-conversions": _vm.canDisputeConversions,
                  "dispute-call-status": _vm.disputeCallStatus,
                  "can-export-report": _vm.canExportReport,
                  "open-columns-tool-panel": _vm.openGridColumnToolPanel,
                  "open-tour-call-details": _vm.openTourCallDetails,
                  "show-export-loader": _vm.showExportLoader,
                  "pending-bulk-call-adjustment-by-logs":
                    _vm.pendingBulkAdjustmentByLogs
                },
                on: {
                  getCallDetails: _vm.getCallDetailsFromAPI,
                  showAudioPlayer: _vm.showAudioPlayer,
                  stopAudioPlayer: _vm.stopAudioPlayer,
                  gridStateChange: _vm.onGridStateChange,
                  blockNumber: _vm.onBlockNumber,
                  blockMultipleNumbers: _vm.blockMultipleNumbers,
                  unblockNumber: _vm.onUnblockNumber,
                  annotateMultipleCalls: _vm.annotateMultipleCalls,
                  annotateCall: _vm.annotateCall,
                  callPaymentDispute: _vm.callPaymentDispute,
                  adjustMultipleCalls: _vm.multipleCallPaymentDispute,
                  adjustMultipleCallsByLogs:
                    _vm.multipleCallPaymentDisputeByLogs,
                  transcribeMultipleCalls: _vm.multipleCallTranscription,
                  transcribeMultipleCallsByLogs:
                    _vm.multipleCallTranscriptionByLogs,
                  onGridDataLoaded: _vm.onGridDataLoaded,
                  changeCallLogActionFormVisibilityStatus:
                    _vm.setCallLogActionFormVisibilityStatus,
                  filterByColumn: _vm.handleFilterByColumn,
                  resetColumnState: _vm.onColumnReset,
                  exportReport: _vm.handleReportExport,
                  exportReportJSONRequestBody:
                    _vm.handleExportReportJSONRequestBody
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("v-tour", {
        attrs: {
          name: "callLogsTour",
          steps: _vm.steps,
          callbacks: _vm.tourCallbacks
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(tour) {
              return [
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  _vm._l(tour.steps, function(step, index) {
                    return tour.currentStep === index
                      ? _c(
                          "v-step",
                          {
                            key: index,
                            attrs: {
                              step: step,
                              "previous-step": tour.previousStep,
                              "next-step": tour.nextStep,
                              stop: tour.stop,
                              "is-first": tour.isFirst,
                              "is-last": tour.isLast,
                              labels: tour.labels,
                              highlight: step.highlight
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "v-step__header",
                                attrs: { slot: "header" },
                                slot: "header"
                              },
                              [
                                _c("span"),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      step.header ? step.header.title : ""
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.dontShowTourAgain(
                                          tour.currentStep
                                        )
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-times" })]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { attrs: { slot: "actions" }, slot: "actions" },
                              [
                                !tour.isFirst
                                  ? _c("button", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "TOUR_PREVIOUS",
                                          expression: "'TOUR_PREVIOUS'"
                                        }
                                      ],
                                      staticClass:
                                        "btn btn-default btn-default--vue-tour btn-sm m-r-5",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return tour.previousStep.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !tour.isLast
                                  ? _c("button", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "TOUR_NEXT",
                                          expression: "'TOUR_NEXT'"
                                        }
                                      ],
                                      staticClass: "btn btn-primary btn-sm",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return tour.nextStep.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                tour.isLast
                                  ? _c("button", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "TOUR_FINISH",
                                          expression: "'TOUR_FINISH'"
                                        }
                                      ],
                                      staticClass: "btn btn-primary btn-sm",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return tour.finish.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  }),
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.audioInfo
        ? _c("AudioPlayer", {
            ref: "audioPlayer",
            attrs: { "audio-info": _vm.audioInfo },
            on: {
              hidePlayer: _vm.hidePlayer,
              viewTranscription: _vm.viewTranscription
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }